import { createFeatureSelector, createSelector, State } from '@ngrx/store';
import * as fromReminder from './reminder.reducer';

export const selectReminderState = createFeatureSelector<fromReminder.State>(
    fromReminder.remindersFeatureKey
);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromReminder.adapter.getSelectors(selectReminderState);

export const selectReminderTypes = createSelector(
    selectReminderState,
    (state: fromReminder.State) => state.reminderTypes
);
export const selectReminderScheduleTypes = createSelector(
    selectReminderState,
    (state: fromReminder.State) => state.reminderScheduleTypes
);
export const selectReminderRecipients = createSelector(
    selectReminderState,
    (state: fromReminder.State) => state.recipients
);
export const selectReminderReviewPeriods = createSelector(
    selectReminderState,
    (state: fromReminder.State) => state.reminderReviewPeriods
);
